import { c } from 'ttag';

export const billedUserWarning = c('Payments')
    .t`We are processing your payment for the billed invoice. Please wait until the payment is completed before making changes to your plan or updating your payment details. Thank you for your patience.`;
